export const NOTES_TYPES = Object.freeze({
  note: "note",
  form: "form",
  assessment: "assessment",
} as const);

/**
 * types that template editor can accpet
 * on which, will decide which jsonSchema, uiSchema... to edit
 */
export type TNotesType = typeof NOTES_TYPES[keyof typeof NOTES_TYPES];
